module.exports = __webpack_public_path__ + "static/media/office.f4ec2462.png";